import React from "react";

import { Card, Col, Divider, Form, Row } from "antd";
import IntlMessages from "../../util/IntlMessages";
import "../../styles/modules/reference.less";
import RefDoctorForm from "./component/RefDoctorForm";
import Auxiliary from "../../util/Auxiliary";

const ReferenceDoctorAddNew = () => {
  return (
    <Auxiliary>
      <Card>
        <Row>
          <Col span={24}>
            <h1 className="text">
              {
                <IntlMessages
                  id={"Addnew.referencedoctor.label.addreferencedoctor"}
                />
              }
            </h1>
          </Col>
          <Divider />
        </Row>
        <RefDoctorForm />
      </Card>
    </Auxiliary>
  );
};

export default ReferenceDoctorAddNew;
